import { Default, Detail,  List, Create } from "./views";

const Module = {
	name: "audienceblacklist",
	defaultRoutePath: "/audiences/audienceblacklist",
	menuItemScope: "audience",
	menuItemName: "audienceBlackLists",

    routes: [
        {
            path: "/audiences/audienceblacklist",
            protected: true,
            children: [
                {
                    index: true,
                    path: "",
                    Component: Default,
                },
                {
                    path: "list",
                    Component: List,
                },
            ],
        },
    ],
    drawerRoutes: [
        {
            path: "list",
            Component: List,
        },
        {
            path: "detail",
            Component: Detail,
        },
        
        {
            path: "create",
            Component: Create,
        },
    ],

}

export default Module;
